var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import DataSourceResource from "../../../DataSource.resource.js";
import { convertToOverridePostParams } from "../../DataSourceOverrideCreate/components/CreateWizard/DataSourceCreateFormSettings.js";
import { convertToPostParams } from "../components/CreateWizard/DataSourceCreateFormSettings.js";
const defaultReducerState = {
  items: getDefaultAsyncWrapperObj()
};
const prefix = "loadDataSourceDuplicate";
const loadDataSourceDuplicateConstants = {
  SetDataSourceDuplicateItem: `${prefix}/SetDataSourceDuplicateItem`
};
const loadDulplicateDataSourcesArgs = {
  actionPrefix: `${prefix}/LOAD`,
  reduxKeyNested: () => ["items"],
  loadResource: (inputPayload) => {
    let dataSourcePost;
    if (inputPayload.IsOverrideDataSource) {
      dataSourcePost = convertToOverridePostParams(inputPayload);
    } else {
      dataSourcePost = convertToPostParams(inputPayload);
    }
    return DataSourceResource.postDuplicateDataSource(dataSourcePost);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadDulplicateDataSourcesEpicReducer = loadResourcesUtils(loadDulplicateDataSourcesArgs);
const dataSourceDuplicateReducer = (state = defaultReducerState, action) => {
  state = loadDulplicateDataSourcesEpicReducer.reduxChange(state, action);
  if (action.type === loadDataSourceDuplicateConstants.SetDataSourceDuplicateItem) {
    return __spreadProps(__spreadValues({}, state), {
      items: action.payload
    });
  }
  return state;
};
function SetDataSourceDuplicateItem(deleteDataSource) {
  return {
    type: loadDataSourceDuplicateConstants.SetDataSourceDuplicateItem,
    payload: deleteDataSource.items
  };
}
export {
  SetDataSourceDuplicateItem,
  dataSourceDuplicateReducer,
  dataSourceDuplicateReducer as default,
  defaultReducerState,
  loadDataSourceDuplicateConstants,
  loadDulplicateDataSourcesEpicReducer
};
//# sourceMappingURL=DataSourceDuplicate.ducks.js.map
